import { ItinerarySectionType, TimelineEventType } from '../../../src/store/facade/facadeApiV3';
import type { Itinerary } from '../../../src/store/tour/tourSlice';

const baseSummary = {
    distance: 315269,
    duration: 13500,
    evConsumption: 123,
    evChargingDuration: 456,
    driverCost: 0.8,
    vehicleCost: 10.01,
    energyCost: 30.01,
    minTotalCost: 45.03,
    maxTotalCost: 55.3,
    minTollCost: 5.01,
    maxTollCost: 10.01,
};

export const mockItineraryWithDrivingCoords: Itinerary = {
    itineraryId: 'tour-1',
    summary: baseSummary,
    sections: [
        {
            sectionId: 1,
            type: ItinerarySectionType.Driving,
            departureTime: '2023-09-11T08:00:00.000Z',
            arrivalTime: '2023-09-11T10:00:00.000Z',
            distance: 200000,
            duration: 7200,
            evConsumption: 80,
            evBatteryCapacityDeparture: 300,
            evBatteryCapacityArrival: 220,
            spans: [
                {
                    index: 0,
                    ev_consumption: 40,
                    distance: 100000,
                    duration: 3600,
                    coordinates: [
                        { latitude: 38.726334, longitude: -9.14952 },
                        { latitude: 39.5467, longitude: -8.9865 },
                    ],
                },
                {
                    index: 1,
                    ev_consumption: 40,
                    distance: 100000,
                    duration: 3600,
                    coordinates: [
                        { latitude: 39.5467, longitude: -8.9865 },
                        { latitude: 40.3435, longitude: -8.5968 },
                    ],
                },
            ],
        },
        {
            sectionId: 2,
            type: ItinerarySectionType.Driving,
            departureTime: '2023-09-11T10:40:00.000Z',
            arrivalTime: '2023-09-11T11:45:00.000Z',
            distance: 115269,
            duration: 3900,
            evConsumption: 43,
            evBatteryCapacityDeparture: 280,
            evBatteryCapacityArrival: 237,
            spans: [
                {
                    index: 0,
                    ev_consumption: 43,
                    distance: 115269,
                    duration: 3900,
                    coordinates: [
                        { latitude: 40.3435, longitude: -8.5968 },
                        { latitude: 41.14584, longitude: -8.610815 },
                    ],
                },
            ],
        },
    ],
    drivingCoordinates: [
        { latitude: 38.726334, longitude: -9.14952 },
        { latitude: 39.5467, longitude: -8.9865 },
        { latitude: 40.3435, longitude: -8.5968 },
        { latitude: 41.14584, longitude: -8.610815 },
    ],
    events: {
        timelineEvents: [
            {
                eventId: 0,
                occurredAt: '2023-09-11T08:00:00.000Z',
                timelineEventType: TimelineEventType.Departure,
                address: {
                    name: 'Departure Location',
                    street: 'Avenida Fontes Pereira de Melo',
                    city: 'Lisboa',
                    countryCode: 'PRT',
                    postalCode: '1050',
                },
                coordinates: { latitude: 38.726334, longitude: -9.14952 },
                expectedBatteryLevelAtDeparture: 300,
            },
            {
                eventId: 1,
                occurredAt: '2023-09-11T09:00:00.000Z',
                timelineEventType: TimelineEventType.IntermediateStop,
                waypointId: 1,
                address: {
                    name: 'Stop 1',
                    street: 'Rua Example',
                    city: 'Coimbra',
                    countryCode: 'PRT',
                    postalCode: '3000-001',
                },
                coordinates: { latitude: 39.5467, longitude: -8.9865 },
                duration: 1800,
                weightDelta: 100,
            },
            {
                eventId: 2,
                occurredAt: '2023-09-11T10:00:00.000Z',
                timelineEventType: TimelineEventType.ChargeStop,
                waypointId: 2,
                stationName: 'Coimbra Fast Charger',
                address: {
                    name: 'Charge Station',
                    street: 'Rua da Estacao',
                    city: 'Aveiro',
                    countryCode: 'PRT',
                    postalCode: '3800-001',
                },
                coordinates: { latitude: 40.3435, longitude: -8.5968 },
                expectedBatteryLevelAtArrival: 220,
                expectedBatteryLevelAtDeparture: 280,
                minDuration: 1200,
                maxDuration: 2400,
                stationId: 'e622e18e-e640-429c-a526-4cdfda81281e',
                power: 50,
            },
            {
                eventId: 3,
                occurredAt: '2023-09-11T11:45:00.000Z',
                timelineEventType: TimelineEventType.Arrival,
                address: {
                    name: 'Arrival Location',
                    street: 'Praça de Almeida Garrett',
                    city: 'Porto',
                    countryCode: 'PRT',
                    postalCode: '4000-069',
                },
                coordinates: { latitude: 41.14584, longitude: -8.610815 },
                expectedBatteryLevelAtArrival: 237,
            },
        ],
    },
};

export const mockItinerary2: Itinerary = {
    ...mockItineraryWithDrivingCoords,
    itineraryId: 'tour-2',
    summary: { ...baseSummary, distance: 340000, duration: 15200, minTotalCost: 50.1, maxTotalCost: 62.4 },
    sections: [
        {
            sectionId: 1,
            spans: [
                {
                    coordinates: [
                        { latitude: 38.726334, longitude: -9.14952 },
                        { latitude: 39.75, longitude: -8.65 },
                        { latitude: 41.14584, longitude: -8.610815 },
                    ],
                },
            ],
        },
    ],
    drivingCoordinates: [
        { latitude: 38.726334, longitude: -9.14952 },
        { latitude: 39.75, longitude: -8.65 },
        { latitude: 41.14584, longitude: -8.610815 },
    ],
};

export const mockItinerary3: Itinerary = {
    ...mockItineraryWithDrivingCoords,
    itineraryId: 'tour-3',
    summary: { ...baseSummary, distance: 290000, duration: 14800, minTotalCost: 42.0, maxTotalCost: 51.0 },
    sections: [
        {
            sectionId: 1,
            spans: [
                {
                    coordinates: [
                        { latitude: 38.726334, longitude: -9.14952 },
                        { latitude: 39.3, longitude: -9.1 },
                        { latitude: 41.14584, longitude: -8.610815 },
                    ],
                },
            ],
        },
    ],
    drivingCoordinates: [
        { latitude: 38.726334, longitude: -9.14952 },
        { latitude: 39.3, longitude: -9.1 },
        { latitude: 41.14584, longitude: -8.610815 },
    ],
};
